import Vue from 'vue'
import * as Types from './types'

export default {
  [Types.SET_BADGES](state, badges) {
    if (badges && Array.isArray(badges)) {
      Vue.set(state, 'badges', badges)
    }
  }
}